module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-dusty-rose-3-2d534490d8f00068b35d2a837339024e.webp";